import { useState } from 'react';
import { Image, Drawer } from '@mantine/core';

import cn from 'classnames';
import css from '../../styles/Header.module.scss';

const mobileMenuDrawerStyle = {
  header: {
    background: css.background,
    margin: 0,
  },
  closeButton: {
    width: 48,
    height: 48,
    color: '#ffffff',
  },
};

export default function Header() {
  const [opened, setOpened] = useState(false);
  const toggleMenu = () => setOpened(!opened);

  const mainMenu = (
    <>
      <li>
        <a href="/">Habbo X Alpha 2</a>
      </li>
      <li>
        <a href="/">Habbo X Rooms</a>
      </li>
      <li>
        <a href="/collabs">Collabs</a>
      </li>
      <li>
        <a href="/navigator">Navigator</a>
      </li>
      <li>
        <a href="https://help.habbox.game/">FAQ</a>
      </li>
    </>
  );

  const secondaryMenu = (
    <>
      <li>
        <a href="https://opensea.io/collection/habbo-avatars">
          <Image src="/avatar_icon.svg" alt="Habbo Avatar" width={24} />
          {/* Habbo Avatars */}
        </a>
      </li>

      <li>
        <a href="https://nft.habbo.com" target="_blank" rel="noreferrer">
          <Image src="/habbo_icon.png" alt="nft.habbo.com" width={24} />
          {/* nft.habbo.com */}
        </a>
      </li>
    </>
  );

  const rightMenu = (
    <>
      <li>
        <a
          href="https://habbonft.medium.com/"
          target="_blank"
          className={css.circleBtn}
          rel="noreferrer"
        >
          <Image src="/micon.svg" alt="M" width={24} />
        </a>
      </li>

      <li>
        <a
          href="https://discord.gg/tCy9T5gNus"
          target="_blank"
          className={css.circleBtn}
          rel="noreferrer"
        >
          <Image src="/discord.svg" alt="Discord" width={24} />
        </a>
      </li>

      <li>
        <a
          href="https://twitter.com/habbonft"
          target="_blank"
          className={css.circleBtn}
          rel="noreferrer"
        >
          <Image src="/twitter.svg" alt="Twitter" width={24} />
        </a>
      </li>
    </>
  );

  return (
    <header className={cn(css.header)}>
      <div className={css.topMenu}>
        <a href="/" className={css.logo}>
          <Image src="/logo.png" alt="Habbo X" />
        </a>

        <ul className={css.menu}>{mainMenu}</ul>

        <ul className={css.rightMenu}>{secondaryMenu}</ul>

        <ul className={cn(css.rightMenu, css.buttons)}>{rightMenu}</ul>

        <div className={css.mobileMenu}>
          <Image src="/menu.svg" height={32} alt="Menu" onClick={toggleMenu} />
        </div>
      </div>

      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        zIndex={9999}
        position="right"
        size="100%"
        withCloseButton={false}
        styles={mobileMenuDrawerStyle}
      >
        <div className={css.xsDrawerMenu}>
          <div className={css.logoHeader}>
            <a href="/" className={css.logo}>
              <Image src="/logo.png" alt="Habbo X" width={35} />
            </a>

            <Image
              src="/close.svg"
              height={32}
              width={32}
              alt="Close"
              onClick={toggleMenu}
            />
          </div>

          <ul>{mainMenu}</ul>
          <div className={css.menuDivider} />
          <ul className={css.secondaryMenu}>
            {secondaryMenu}

            <li>
              <a
                href="https://habbonft.medium.com/"
                target="_blank"
                rel="noreferrer"
              >
                <Image src="/micon.svg" alt="M" width={24} /> MEDIUM
              </a>
            </li>

            <li>
              <a
                href="https://discord.gg/tCy9T5gNus"
                target="_blank"
                rel="noreferrer"
              >
                <Image src="/discord.svg" alt="Discord" width={24} /> DISCORD
              </a>
            </li>

            <li>
              <a
                href="https://twitter.com/habbonft"
                target="_blank"
                rel="noreferrer"
              >
                <Image src="/twitter.svg" alt="Twitter" width={24} /> TWITTER
              </a>
            </li>
          </ul>
        </div>
      </Drawer>
    </header>
  );
}
